/* @flow */
import React, { useContext, useState } from "react";
import Store from "nexia_mobile/flux_like/store";
import Dispatch from "nexia_mobile/flux_like/dispatch";
import AlertDialog from "nexia_mobile/components/Dialogs/AlertDialog";
import LanguageContext from "nx-components/ContextWrappers/LanguageContext";

const PivotDemoMessage = () => {
  const languageContext = useContext(LanguageContext);
  const language = languageContext.localeSet.nexia_mobile.PivotDemoMessage;
  const [isDemoMessageOpen: boolean, setIsDemoMessageOpen] = useState(
    Store.appState && Store.appState.inDemoMode && Store.appState.isFirstVisit
  );

  const dismissDemoMessage = () => {
    setIsDemoMessageOpen(false);
    Dispatch("APP_FIRST_DEMO_VISIT");
  };

  return (
    <AlertDialog
      message={language.demoMessage}
      buttonText={language.okButton}
      onDismiss={dismissDemoMessage}
      open={isDemoMessageOpen}
    />
  );
};

export default PivotDemoMessage;



// WEBPACK FOOTER //
// ./src/components/Commercial/PivotDemoMessage.jsx